// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"76ee1513","453":"37e97140"}[chunkId] + ".chunk.js";
};